import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PopoverService {
    // Event émis lorsqu'un popover est ouvert
    popoverOpened = new EventEmitter<string>();

    // Notifier que ce popover a été ouvert
    notifyPopoverOpened(id: string): void {
        this.popoverOpened.emit(id);
    }
}
